export enum UsageVariant {
  Frontend = 1,
  Embedded = 2,
  CRM = 3
}
